import logoutIconWhite from "../images/logout-white.svg";

const headerClass = "header";
const headerInactiveClass = "header__inactive";
const mobileHeaderClass = "header__mobile";
const headerUserIcon = logoutIconWhite;
const headerLogoClass = "header__logo";
const headerLogoHamburgerClass = "header__logo header__logo_hamburger";
const headerHamburgerMenuCloseClass = "header__hamburger-menu-close-btn";
const headerHamburgerMenuClass = "header__hamburger-menu-btn";
const headerMenuClass = "header__menu";
const headerMenuMobileClass = "header__menu-mobile";
const headerMenuButtonClass = "header__button";
const headerMenuLoggedInClass = "header__button-loggedin header__button-loggedin_active";
const headerMenuLoggedOutClass = "header__button-loggedin";
const headerUserButtonClass = "header__user-button";
const headerLogoutButtonInactiveClass = "header__logout-button";
const headerLogoutButtonActiveClass = "header__logout-button header__logout-button_active";

export {
  headerClass,
  headerInactiveClass,
  mobileHeaderClass,
  headerUserIcon,
  headerLogoClass,
  headerLogoHamburgerClass,
  headerHamburgerMenuCloseClass,
  headerHamburgerMenuClass,
  headerMenuClass,
  headerMenuMobileClass,
  headerMenuButtonClass,
  headerMenuLoggedInClass,
  headerMenuLoggedOutClass,
  headerUserButtonClass,
  headerLogoutButtonInactiveClass,
  headerLogoutButtonActiveClass,
};
